import { Reveal } from './Reveal';

export const SectionHeading = ({ chapter, eyebrow, title, copy, dark = false, className = '' }) => (
  <div className={`max-w-3xl ${className}`}>
    <Reveal>
      <div className="mb-5 flex items-center gap-4">
        {chapter && (
          <span
            className={`font-mono text-xs tracking-[0.28em] ${dark ? 'text-goldlight' : 'text-gold'}`}
          >
            {chapter}
          </span>
        )}
        <span className="gold-rule" aria-hidden="true" />
        <span className="eyebrow">{eyebrow}</span>
      </div>
    </Reveal>
    <Reveal delay={0.08}>
      <h2
        className={`text-balance font-display text-3xl font-bold leading-[1.12] tracking-tight sm:text-4xl lg:text-5xl ${
          dark ? 'text-white' : 'text-ink'
        }`}
      >
        {title}
      </h2>
    </Reveal>
    {copy && (
      <Reveal delay={0.16}>
        <p className={`mt-6 text-base leading-relaxed sm:text-lg ${dark ? 'text-white' : 'text-ink'}`}>
          {copy}
        </p>
      </Reveal>
    )}
  </div>
);
